import axios from "axios";
const state = {
    groups:[
        {
             group: "Leche descremada",
             cero:0,
             HC:12,
             gHCO:12,
             PS:9,
             gPS:9,
             LP:2,
             gLP:2,
             Kcal_per_1_equivalent:95
        },
        {
             group: "Semidescremada",
             cero:110,
             HC:12,
             gHCO:12,
             PS:9,
             gPS:9,
             LP:4,
             gLP:4,
             Kcal_per_1_equivalent:110
        },
        {
             group: "Entera",
             cero:150,
             HC:12,
             gHCO:12,
             PS:9,
             gPS:9,
             LP:8,
             gLP:8,
             Kcal_per_1_equivalent:150
        },
        {
             group: "Con azúcar",
             cero:200,
             HC:30,
             gHCO:30,
             PS:8,
             gPS:8,
             LP:5,
             gLP:5,
             Kcal_per_1_equivalent:200
        },
        {
             group: "Frutas",
             cero:60,
             HC:15,
             gHCO:15,
             PS:0,
             gPS:0,
             LP:0,
             gLP:0,
             Kcal_per_1_equivalent:60
        },
        {
             group: "Verduras",
             cero:25,
             HC:4,
             gHCO:4,
             PS:2,
             gPS:2,
             LP:0,
             gLP:0,
             Kcal_per_1_equivalent:25
        },
        {
             group: "Azúcares s/gs",
             cero:40,
             HC:10,
             gHCO:10,
             PS:0,
             gPS:0,
             LP:0,
             gLP:0,
             Kcal_per_1_equivalent:40
        },
        {
             group: "Azúcares c/gs",
             cero:85,
             HC:10,
             gHCO:10,
             PS:0,
             gPS:0,
             LP:5,
             gLP:5,
             Kcal_per_1_equivalent:85
        },
        {
             group: "Leguminosas",
             cero:120,
             HC:20,
             gHCO:20,
             PS:8,
             gPS:8,
             LP:1,
             gLP:1,
             Kcal_per_1_equivalent:120
        },
        {
             group: "Cereales s/gs",
             cero:70,
             HC:15,
             gHCO:15,
             PS:2,
             gPS:2,
             LP:0,
             gLP:0,
             Kcal_per_1_equivalent:70
        },
        {
             group: "Cereales c/gs",
             cero:115,
             HC:15,
             gHCO:15,
             PS:2,
             gPS:2,
             LP:5,
             gLP:5,
             Kcal_per_1_equivalent:115
        },
        {
             group: "A.O.Animal MBAGs",
             cero:40,
             HC:0,
             gHCO:0,
             PS:7,
             gPS:7,
             LP:1,
             gLP:1,
             Kcal_per_1_equivalent:40
        },
        {
             group: "A.O.A BAGs",
             cero:55,
             HC:0,
             gHCO:0,
             PS:7,
             gPS:7,
             LP:3,
             gLP:3,
             Kcal_per_1_equivalent:55
        },
        {
             group: "A.O.A MAGs",
             cero:75,
             HC:0,
             gHCO:0,
             PS:7,
             gPS:7,
             LP:5,
             gLP:5,
             Kcal_per_1_equivalent:75
        },
        {
             group: "A.O.A AAGs",
             cero:100,
             HC:0,
             gHCO:0,
             PS:7,
             gPS:7,
             LP:8,
             gLP:8,
             Kcal_per_1_equivalent:100
        },
        {
             group: "Aceites y Gs c/ps",
             cero:70,
             HC:0,
             gHCO:0,
             PS:3,
             gPS:3,
             LP:5,
             gLP:5,
             Kcal_per_1_equivalent:70
        },
        {
             group: "Aceites y Gs s/ps",
             cero:45,
             HC:0,
             gHCO:0,
             PS:0,
             gPS:0,
             LP:5,
             gLP:5,
             Kcal_per_1_equivalent:45
        }
   ]
};
const getters = {};

const actions = {
  
};

const mutations = {
  
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}